export default __webpack_public_path__ + "static/media/timer.5e93067d.svg";